import { render } from "./DashboardCaseCountGraph.vue?vue&type=template&id=67ece3f0&scoped=true"
import script from "./DashboardCaseCountGraph.vue?vue&type=script&lang=js"
export * from "./DashboardCaseCountGraph.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-67ece3f0"
/* hot reload */
if (module.hot) {
  script.__hmrId = "67ece3f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67ece3f0', script)) {
    api.reload('67ece3f0', script)
  }
  
  module.hot.accept("./DashboardCaseCountGraph.vue?vue&type=template&id=67ece3f0&scoped=true", () => {
    api.rerender('67ece3f0', render)
  })

}

script.__file = "src/components/dashboard/DashboardCaseCountGraph.vue"

export default script